import React, { useMemo } from 'react';
import { useProfileQuery, UserPreferences } from '../../graphql/types';

export interface PercentTextProps {
  value: number;
}

export const Percent = new Intl.NumberFormat('en-US', {
  style: 'percent',
  maximumFractionDigits: 2
});

export const PercentText = ({ value }: PercentTextProps) => {
  const { data, loading, refetch } = useProfileQuery({ fetchPolicy: 'cache-first' });
  const preferences = useMemo(() => data?.profile.preferences as UserPreferences, [data]);
  if (preferences?.showTrailingZeros) {
    return <>{Percent.format(value / 100)}</>;
  }
  return <>{Percent.format(value / 100).replace(/\.0+$/, '')}</>;
};
